import { clsx } from 'clsx'
import { Img } from 'component/Image'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import css from './Collage.module.scss'

type Size = 'large' | 'small' | 'tiny'
type BadgeType = 'good' | 'bad'

export type CollageItem = {
  src: string
  size: Size
}

type Props = {
  items: [CollageItem, CollageItem, CollageItem]
  badge?: BadgeType
  // Порядок наложения: по умолчанию сверху лежит левая плитка, с флагом — правая.
  back?: boolean
}

const Badge = observer(({ badge }: { badge: BadgeType }) => {
  const good = badge === 'good'
  return (
    <Space className={css.badge}>
      <Space className={clsx(css.mark, good ? css.markGood : css.markBad)} center>
        <Icon size={18} name={good ? 'check' : 'close'} />
      </Space>
      <Typo size={18} medium>
        {good ? i18n('Correct') : i18n('Incorrect')}
      </Typo>
    </Space>
  )
})

// Плитки перекрывают друг друга на 32px, бейдж центрируется по большой плитке.
export const Collage = observer(({ items, badge, back }: Props) => {
  return (
    <Space className={css.collage}>
      {items.map((item, index) => {
        const overlap = index < items.length - 1 && css.overlap
        const zIndex = back ? index + 1 : items.length - index
        return (
          <Space key={index} className={clsx(css.slot, overlap)} style={{ zIndex }}>
            <Img className={clsx(css.image, css[item.size])} src={item.src} cover />
            {badge && item.size === 'large' && <Badge badge={badge} />}
          </Space>
        )
      })}
    </Space>
  )
})
